import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";

const HorizontalScroll = ({ renderServices, activeTab, setActiveTab }) => {
  const scrollContainerRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    updateScrollButtons();

    scrollContainer.addEventListener("scroll", updateScrollButtons);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollButtons);
  }, []);

  const handleScroll = (direction) => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const scrollAmount = direction === "left" ? -200 : 200;
    scrollContainer.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  const updateScrollButtons = () => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        ref={scrollContainerRef}
        sx={{
          display: "flex",
          gap: 2,
          padding: 2,
          mt: 2,
          overflowX: "auto",
          scrollBehavior: "smooth",
          mb: 2,
          flexWrap: "nowrap",
          "& > :last-child": {
            marginRight: "2px",
          },

          "&::-webkit-scrollbar": {
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: appcolors.primary,
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f0f0f0",
            borderRadius: "10px",
          },
        }}
      >
        {renderServices?.map((item, index) => (
          <GlobalButton
            key={index}
            variant={"contained"}
            handleClickBtn={() => setActiveTab({ ...item, index })}
            btnText={`${item?.name}`}
            hoverProperties={{
              bgcolor:
                item?._id === activeTab?._id
                  ? appcolors.primary
                  : appcolors.white,
              color:
                item?._id === activeTab?._id
                  ? appcolors.white
                  : appcolors.darkGrey,
            }}
            styleProps={{
              minWidth: "auto",
              whiteSpace: "nowrap",
              height: 30,
              bgcolor:
                item?._id === activeTab?._id
                  ? appcolors.primary
                  : appcolors.white,
              color:
                item?._id === activeTab?._id
                  ? appcolors.white
                  : appcolors.darkGrey,
              fontWeight: 400,
              fontSize: "0.875rem",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default HorizontalScroll;
